import React from "react";
import { CloseIcon } from "../../../../../../components/icons";
import { useBookingEditText } from "../../../text";
import { cn } from "../../../../../../utils/classnames";
import CancellationFeeInformationModal from "./CancellationFeeInformationModal";

const ChargeConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  amountText,
  isSubmittingModification,
  oldBooking,
  chargeAmountNumber,

  hasCancellationPolicy,
  getTypographyClass,
  editFeeCalculation,
  paymentStatus,
  deferredPayment,
  newBookingTotalPrice,
  openPolicyModal,
  changes,
  oldBookingPrice,
  meetAssistChangesIdentification,

}) => {
  const { t } = useBookingEditText();

  const getTitle = () => {
    if (oldBooking.paymentStatus === "CHARGE_PENDING" && chargeAmountNumber === 0) {
      return {
        title: "Would you like to update the booking details?",
        subtitle: "Please make sure to review all modifications thoroughly, as changes are irreversible"
      }
    }

    if (oldBooking.paymentStatus === "CHARGE_PENDING" && chargeAmountNumber > 0) {
      return {
        title: `Would you like to update the booking details and charge the amount of ${amountText} ?`,
        subtitle: "Please make sure to review all modifications thoroughly, as changes are irreversible"
      }
    }

    if (hasCancellationPolicy) {
      return {
        title: "Would you like to update the booking details?",
        subtitle: "Please make sure to review all modifications thoroughly, as changes are irreversible"
      }
    }

    return {
      title: `Would you like to update the booking details and charge the additional amount of ${amountText} ?`,
      subtitle: "Please make sure to review all modifications thoroughly, as changes are irreversible"
    }
  };

  const getConfirmationButtonText = () => {
    if (isSubmittingModification) {
      return t(
        "editBooking.BookingReviewPage.bookingEditConfirmationModal.updating"
      );
    }

    if (oldBooking.paymentStatus === "CHARGE_PENDING" && chargeAmountNumber === 0) {
      return "Update";
    }

    if (oldBooking.paymentStatus === "CHARGE_PENDING" && chargeAmountNumber > 0) {
      return `¥ ${t("editBooking.BookingReviewPage.chargeConfirmationModal.charge", { amount: amountText })}`;
    }

    if (hasCancellationPolicy) {
      return "Update";
    }

    return `¥ ${t("editBooking.BookingReviewPage.chargeConfirmationModal.charge", { amount: amountText })}`;
  };

  const getConfirmationButtonStyle = () => {
    if (isSubmittingModification) {
      return "tw:bg-[#F3F3F3]";
    }

    if (oldBooking.paymentStatus === "CHARGE_PENDING" && chargeAmountNumber === 0) {
      return "tw:bg-[#DBBE78]";
    }

    if (oldBooking.paymentStatus === "CHARGE_PENDING" && chargeAmountNumber > 0) {
      return "tw:bg-[#3CAEA3]";
    }

    if (hasCancellationPolicy) {
      return "tw:bg-[#DBBE78]";
    }

    return "tw:bg-[#3CAEA3]";
  };

  return (
    <div
      className={cn(
        "tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center",
        show ? "tw:block" : "tw:hidden"
      )}
    >
      <div
        aria-label="Close modal backdrop"
        className="tw:absolute tw:inset-0 tw:bg-[#00000099]"
        onClick={onClose}
      />
      <div className="tw:relative tw:z-[10000] tw:w-[calc(100%-24px)] tw:lg:w-[660px] tw:rounded-[8px] tw:bg-white tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8 tw:shadow-lg">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="tw:absolute tw:top-6 tw:right-6"
        >
          <CloseIcon color="#7c7b7b" size={16} />
        </button>

        <div className="tw:mt-6 tw:mb-6 tw:text-center">
          <div className="tw:mx-auto tw:max-w-[520px] tw:text-[#282828] tw:text-[18px] tw:font-[600] tw:leading-[27px] tw:font-hanken-grotesk">
            {getTitle().title}
          </div>
          {hasCancellationPolicy && (
            <div className="tw:mt-4">
              <CancellationFeeInformationModal
                getTypographyClass={getTypographyClass}
                editFeeCalculation={editFeeCalculation}
                paymentStatus={paymentStatus}
                deferredPayment={deferredPayment}
                newBookingTotalPrice={newBookingTotalPrice}
                openPolicyModal={openPolicyModal}
                changes={changes}
                oldBookingPrice={oldBookingPrice}
                meetAssistChangesIdentification={meetAssistChangesIdentification}
              />
            </div>
          )}
          <div className="tw:mx-auto tw:mt-3 tw:max-w-[520px] tw:text-[#8D8D8D] tw:text-[15px] tw:font-[400] tw:leading-[22px] tw:font-hanken-grotesk">
            {getTitle().subtitle}
          </div>
        </div>

        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-stretch tw:gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmittingModification}
            className="tw:flex-1"
          >
            <div className="tw:py-3 tw:w-full tw:rounded-[8px] tw:border tw:border-[#d0d0d0] tw:bg-white tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-medium tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
              {t("editBooking.BookingReviewPage.chargeConfirmationModal.back")}
            </div>
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isSubmittingModification}
            className="tw:flex-1"
          >
            <div className={`tw:py-3 tw:w-full tw:rounded-[8px] tw:text-white tw:text-[15px] tw:leading-[22px] tw:font-[700] tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center tw:gap-2 ${getConfirmationButtonStyle()}`}>
              <span>
                {getConfirmationButtonText()}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChargeConfirmationModal;
